import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input
} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import {addBaskets} from "scenes/Survey/Structure/data/questions/actions";


class ActionAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      text: '',
      modal: false,
      saving: false,
    };

    this.onChangeText = this.onChangeText.bind(this);
  }

  toggleModal(){
    this.setState({ modal: !this.state.modal });
  }

  onChangeText(text){
    this.setState({
      text
    })
  }

  saveBaskets(){
    const {text, saving} = this.state;
    const {question} = this.props;

    if(_.isEmpty(text) || saving){
      return;
    }

    let baskets = [];

    text.split("\n").map(t => {
      if(t.trim()) {
        baskets.push({
          content: t
        });
      }
    });

    this.setState({
      saving: true
    });
    this.props.addBaskets(question.id, baskets).then(() => {
      this.setState({
        text: '',
        saving: false,
        modal: false,
      });
    });
  }

  render() {
    const {question} = this.props;
    const {text, saving} = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()}>
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="baskets.actions.add.cardHeader"/></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p><FormattedMessage id="baskets.actions.add.cardBody"/></p>
        <Form>
          <FormGroup>
            <Input
              type="textarea"
              disabled={saving}
              rows={10}
              onChange={(e) => this.onChangeText(e.target.value)}
              value={text}
              className="custom"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <div className="direction-group d-flex justify-content-end">
          <div className="direction-right">
            <FormattedMessage id="baskets.actions.add.button.confirmation">{
              (message) => <LaddaButton
                className="btn btn-primary btn-ladda mb-0 ml-3"
                loading={saving}
                data-style={ZOOM_OUT}
                onClick={() => this.saveBaskets()}
              >
                {message}
              </LaddaButton>
            }</FormattedMessage>
            <FormattedMessage id="_.button.cancel">{
              (message) => <Button color="secondary" className="mb-0 ml-3" onClick={() => this.toggleModal()}>{message}</Button>
            }</FormattedMessage>
          </div>
        </div>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button size="sm" onClick={() => this.toggleModal()}><FormattedMessage id="baskets.actions.add.button.add"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

ActionAdd.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired
};


export default connect(null, {addBaskets})(ActionAdd);